
import {
  ACTUALIZAR_INDICADOR_HABILITADO,
} from "../../actions/Otros/types";

import type { IndicadorKey } from "../../actions/Otros/actualizarIndicadorHabilitadoActions";


interface IndicadoresState {
  habilitados: Record<IndicadorKey, boolean>;
  loading: boolean;
  error?: string;
}

interface ActualizarIndicadorAction {
  type: typeof ACTUALIZAR_INDICADOR_HABILITADO;
  payload: {
    id: IndicadorKey;
    habilitado: boolean;
  };
}

const initialState: IndicadoresState = {

  habilitados: {
    UTM: true,
    UF: false,
    Dólar: false,
    IPC: false,
    BTC: false,
    EURO: false,
    Ethereum: false,
  },

  loading: false,
  error: undefined,
};

const actualizarIndicadorHabilitadoReducers = (
  state: IndicadoresState = initialState, action: any): IndicadoresState => {
  switch (action.type) {

    case ACTUALIZAR_INDICADOR_HABILITADO: {
      const typedAction = action as ActualizarIndicadorAction;
      const { id, habilitado } = typedAction.payload;

      return {
        ...state,
        habilitados: {
          ...state.habilitados,
          [id]: habilitado,
        },
      };
    }

    default:
      return state;
  }
};

export default actualizarIndicadorHabilitadoReducers;
